import dayjs from "dayjs";

/**
 * Genera el HTML para imprimir un presupuesto o ficha de paquete grupal
 */
export const generateGroupPrintHTML = (
  producto: any,
  formatearMoneda: (valor: number, moneda: string) => string
): string => {
  if (!producto) return "";

  const metadataObs = (producto.observaciones || []).find((o: any) => o.descripcion?.startsWith("METADATA_GRUPAL:"));
  let data: any = {};
  try {
    if (metadataObs) data = JSON.parse(metadataObs.descripcion.replace("METADATA_GRUPAL: ", ""));
  } catch (e) {}

  const fechaFormateada = dayjs().format("DD/MM/YYYY");
  const salidaFormateada = producto.fechaSalida ? dayjs(producto.fechaSalida).format("DD/MM/YYYY") : "A confirmar";

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <title>Presupuesto Grupal - ${producto.concepto}</title>
      <style>
        @page { size: A4; margin: 15mm; }
        body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #333; line-height: 1.5; font-size: 11px; margin: 0; }
        .container { width: 100%; }
        
        /* Header */
        .header { display: flex; justify-content: space-between; border-bottom: 2px solid #461264; padding-bottom: 10px; margin-bottom: 20px; }
        .logo-container { width: 220px; }
        .logo-container img { width: 100%; max-height: 65px; object-fit: contain; }
        .info-empresa { text-align: right; font-size: 9px; color: #666; font-family: sans-serif; }
        .info-empresa b { color: #461264; font-size: 12px; display: block; margin-bottom: 2px; }

        /* Título */
        .doc-title { text-align: center; background: #461264; color: white; padding: 10px; margin-bottom: 25px; text-transform: uppercase; letter-spacing: 2px; font-weight: 800; font-size: 14px; border-radius: 4px; }

        /* Grids de Datos */
        .grid-info { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px; }
        .card { padding: 12px; border: 1px solid #e0e0e0; background: #fff; border-radius: 6px; box-shadow: 0 1px 3px rgba(0,0,0,0.05); }
        .card-title { font-weight: 800; color: #461264; border-bottom: 2px solid #f4eff7; margin-bottom: 10px; padding-bottom: 5px; text-transform: uppercase; font-size: 10px; letter-spacing: 0.5px; }
        .row { display: flex; justify-content: space-between; margin-bottom: 6px; border-bottom: 1px dotted #f0f0f0; padding-bottom: 2px; }
        .label { font-weight: 700; color: #666; }
        .value { color: #333; }

        /* Tablas */
        table { width: 100%; border-collapse: collapse; margin: 20px 0; border-radius: 6px; overflow: hidden; border: 1px solid #eee; }
        th { background: #461264; color: white; padding: 10px; text-align: left; font-size: 10px; text-transform: uppercase; }
        td { padding: 10px; border-bottom: 1px solid #eee; font-size: 10px; }
        tr:last-child td { border-bottom: none; }
        .text-right { text-align: right; }
        .text-center { text-align: center; }

        /* Totales */
        .totales-container { margin-top: 25px; border: 2px solid #461264; padding: 18px; border-radius: 10px; background: #fdfbff; display: flex; justify-content: space-between; align-items: center; }
        .total-label { font-size: 13px; font-weight: 700; color: #555; }
        .total-value { font-size: 20px; font-weight: 900; color: #461264; }

        /* Legal y Firmas */
        .legal { font-size: 9px; color: #777; margin-top: 40px; text-align: justify; padding: 15px; border: 1px solid #eee; background: #fafafa; border-radius: 6px; line-height: 1.6; }
        .firmas { display: flex; justify-content: space-around; margin-top: 80px; }
        .firma-box { width: 220px; border-top: 1.5px solid #461264; text-align: center; padding-top: 8px; font-size: 11px; font-weight: 600; color: #461264; }
        
        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .no-print { display: none; }
          .container { margin: 0; }
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <div class="logo-container">
            <img src="/logo.png" alt="Turismo Vittorio">
          </div>
          <div class="info-empresa">
            <b>TURISMO VITTORIO S.R.L.</b>
            Legajo 1881 - CUIT 30-61632343-8<br>
            Sarmiento 174 (Sur) - Capital, San Juan<br>
            Tel: (264) 4204000 - info@turismovittorio.com
          </div>
        </div>

        <div class="doc-title">Ficha Técnica de Servicios Grupales</div>

        <div class="grid-info">
          <div class="card">
            <div class="card-title">Información del Cliente</div>
            <div class="row"><span class="label">Responsable:</span> <span class="value">${producto.cliente?.nombre || "-"}</span></div>
            <div class="row"><span class="label">Teléfono:</span> <span class="value">${producto.cliente_telefono || "-"}</span></div>
            <div class="row"><span class="label">Correo:</span> <span class="value">${producto.cliente_correo || "-"}</span></div>
            <div class="row"><span class="label">Fecha Emisión:</span> <span class="value">${fechaFormateada}</span></div>
          </div>
          <div class="card">
            <div class="card-title">Detalles del Destino</div>
            <div class="row"><span class="label">Concepto:</span> <span class="value">${producto.concepto}</span></div>
            <div class="row"><span class="label">Fecha Programada:</span> <span class="value">${salidaFormateada}</span></div>
            <div class="row"><span class="label">Tipo de Producto:</span> <span class="value">${data.categoria || "-"}</span></div>
            <div class="row"><span class="label">Pasajeros Estimados:</span> <span class="value">${producto.adultos || 0}</span></div>
          </div>
        </div>

        <div class="card" style="margin-bottom: 25px; border-color: #461264;">
          <div class="card-title" style="border-bottom-color: #461264;">Itinerario y Prestaciones Incluidas</div>
          ${producto.servicios?.length > 0 ? `
            <table>
              <thead>
                <tr>
                  <th style="width: 50px;">Cód.</th>
                  <th>Servicio Detallado</th>
                  <th style="width: 100px;">Modalidad</th>
                  <th class="text-right" style="width: 120px;">Tarifa Unit.</th>
                </tr>
              </thead>
              <tbody>
                ${producto.servicios.map((s: any) => `
                  <tr>
                    <td>#${s.id || s.id_servicio || "-"}</td>
                    <td><b style="color: #461264;">${s.nombre}</b><br><small style="color: #666;">${s.descripcion || s.tipo || ""}</small></td>
                    <td>${s.tipoPago || "Pasajeros"}</td>
                    <td class="text-right"><b style="font-size: 11px;">${formatearMoneda(s.precioVenta || s.monto || 0, s.moneda || producto.moneda || "USD")}</b></td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          ` : `<p class="text-center" style="padding: 20px; color: #999; font-style: italic;">No se han registrado servicios detallados para este presupuesto.</p>`}
        </div>

        <div class="totales-container">
          <div class="total-label">INVERSIÓN TOTAL ESTIMADA POR PASAJERO:</div>
          <div class="total-value">${formatearMoneda(producto.precioVenta || 0, producto.moneda || "USD")}</div>
        </div>

        <div class="legal">
          <b>CLAUSULAS Y CONDICIONES:</b><br>
          1. <b>Validez:</b> Este presupuesto tiene una validez de 48hs hábiles sujetos a disponibilidad. 2. <b>Reservas:</b> La reserva se hace efectiva únicamente con el pago de la seña estipulada. 3. <b>Documentación:</b> Turismo Vittorio no se responsabiliza por problemas de documentación personal de los pasajeros. 4. <b>Cancelaciones:</b> Toda cancelación deberá ser informada por escrito y estará sujeta a las retenciones aplicadas por los prestadores finales. 5. <b>Responsabilidad:</b> La empresa actúa como intermediaria garantizando la correcta prestación de los servicios contratados conforme a la normativa vigente.
        </div>

        <div class="firmas">
          <div class="firma-box">Sello y Firma Turismo Vittorio</div>
          <div class="firma-box">Conformidad Cliente</div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const printGroupPackage = (
  producto: any,
  formatearMoneda: (valor: number, moneda: string) => string
): void => {
  const html = generateGroupPrintHTML(producto, formatearMoneda);
  const win = window.open("", "_blank");
  if (win) {
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
    }, 600);
  }
};

export const generateDeudoresPrintHTML = (
  producto: any,
  deudores: any[],
  formatearMoneda: (valor: number, moneda: string) => string
): string => {
  if (!producto) return "";

  const fechaFormateada = dayjs().format("DD/MM/YYYY");
  const moneda = producto.moneda || "USD";

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <title>Listado de Deudores - ${producto.concepto}</title>
      <style>
        @page { size: A4; margin: 15mm; }
        body { font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #333; line-height: 1.5; font-size: 10px; margin: 0; }
        .container { width: 100%; }
        
        .header { display: flex; align-items: center; margin-bottom: 20px; gap: 20px; }
        .logo-container { width: 150px; }
        .logo-container img { width: 100%; max-height: 50px; object-fit: contain; }
        
        .title-section { margin-bottom: 30px; }
        .doc-title { font-size: 18px; font-weight: 800; color: #000; margin: 0; display: flex; align-items: center; gap: 10px; }
        .doc-title::after { content: ''; flex: 1; height: 1px; background: #ddd; }
        
        table { width: 100%; border-collapse: collapse; margin: 10px 0; border: 1px solid #ddd; }
        th { background: #f5f5f5; color: #000; padding: 8px 5px; text-align: left; font-size: 9px; text-transform: none; border: 1px solid #ddd; font-weight: 700; }
        td { padding: 6px 5px; border: 1px solid #ddd; font-size: 9px; color: #333; }
        tr:nth-child(even) { background-color: #f9f9f9; }
        
        .text-right { text-align: right; }
        .text-center { text-align: center; }
        
        .footer { margin-top: 20px; text-align: right; font-size: 9px; color: #777; }
        
        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          table { page-break-inside: auto; }
          tr { page-break-inside: avoid; page-break-after: auto; }
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <div class="logo-container">
            <img src="/logo.png" alt="Turismo Vittorio">
          </div>
        </div>

        <div class="title-section">
          <h1 class="doc-title">Listado de deudores | ${producto.concepto.toUpperCase()}</h1>
        </div>

        <table>
          <thead>
            <tr>
              <th style="width: 15%;">Apellido</th>
              <th style="width: 15%;">Nombre</th>
              <th style="width: 12%;" class="text-right">Monto Contrato</th>
              <th style="width: 12%;" class="text-right">Pagado</th>
              <th style="width: 12%;" class="text-right">Saldo</th>
              <th style="width: 14%;">Teléfono</th>
              <th style="width: 20%;">E-mail</th>
            </tr>
          </thead>
          <tbody>
            ${deudores.map((p: any) => `
              <tr>
                <td>${p.apellido.toUpperCase()}</td>
                <td>${p.nombre_solamente.toUpperCase()}</td>
                <td class="text-right">${formatearMoneda(p.precioVenta || 0, moneda)}</td>
                <td class="text-right">${formatearMoneda(p.totalPagado || 0, moneda)}</td>
                <td class="text-right" style="font-weight: 700;">${formatearMoneda(p.saldo || 0, moneda)}</td>
                <td>${p.telefono || "-"}</td>
                <td>${p.email || "-"}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <div class="footer">
          Fecha de emisión: ${fechaFormateada} | Hoja 1
        </div>
      </div>
    </body>
    </html>
  `;
};

export const printDeudores = (
  producto: any,
  deudores: any[],
  formatearMoneda: (valor: number, moneda: string) => string
): void => {
  const html = generateDeudoresPrintHTML(producto, deudores, formatearMoneda);
  const win = window.open("", "_blank");
  if (win) {
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
    }, 800);
  }
};

/**
 * Genera el HTML para imprimir la ficha individual de un pasajero
 */
export const generatePassengerFileHTML = (
  pasajero: any,
  tripName: string = "15 FOREVER",
  tripYear: string = "2028",
  packageType: string = "QUINCE"
): string => {
  if (!pasajero) return "";

  const PINK = "#e73c8d";
  const BG_LABEL = "#f5f1ea";
  const nameParts = (pasajero.nombre || "").split(',');
  const apellido = (pasajero.apellido || nameParts[0]?.trim?.() || nameParts[0] || '').toUpperCase();
  const nombre = (pasajero.nombre_solamente || nameParts[1]?.trim?.() || nameParts[1] || '').toUpperCase();

  const renderRow = (label: string, value: any) => `
    <div class="info-row">
      <div class="info-label">${label}</div>
      <div class="info-value">${value === true ? 'SI' : value === false ? 'NO' : (value || '-')}</div>
    </div>
  `;

  return `
    <!DOCTYPE html>
    <html lang="es">
    <head>
      <meta charset="UTF-8">
      <title>Ficha Pasajero - ${apellido} ${nombre}</title>
      <style>
        @page { size: A4; margin: 10mm; }
        body { font-family: 'Segoe UI', Arial, sans-serif; color: #333; margin: 0; padding: 0; font-size: 10pt; }
        .outer-border { border: 2.5px solid ${PINK}; padding: 3mm; border-radius: 2mm; height: 270mm; position: relative; }
        .inner-border { border: 1px solid ${PINK}; padding: 8mm; height: calc(100% - 16mm); background: white; }
        
        .header { text-align: center; margin-bottom: 25px; }
        .logo-text { font-size: 32pt; font-weight: 900; color: ${PINK}; letter-spacing: 5pt; line-height: 1; margin: 0; }
        .logo-subtext { font-size: 9pt; font-weight: 800; color: ${PINK}; letter-spacing: 4pt; margin-top: 2pt; display: block; }
        .pasajero-nombre { font-size: 20pt; font-weight: 800; color: ${PINK}; margin-top: 15pt; text-transform: uppercase; }
        .viaje-info { font-size: 12pt; font-weight: 700; color: ${PINK}; margin-top: 5pt; }

        .section-title { color: ${PINK}; font-size: 10pt; font-weight: 900; margin: 15pt 0 8pt 0; letter-spacing: 1pt; text-transform: uppercase; border-bottom: 1px solid rgba(231, 60, 141, 0.2); padding-bottom: 2pt; }
        
        .grid-container { display: grid; grid-template-columns: 1fr 1fr; gap: 20pt; }
        
        .info-row { display: flex; margin-bottom: 3pt; align-items: stretch; height: 18pt; }
        .info-label { width: 130pt; background: ${BG_LABEL}; border: 0.5pt solid #ddd; display: flex; align-items: center; justify-content: flex-end; padding-right: 8pt; font-size: 7.5pt; font-weight: 800; text-transform: uppercase; }
        .info-value { flex: 1; border: 0.5pt solid #ddd; display: flex; align-items: center; padding-left: 8pt; font-size: 9pt; font-weight: 600; }

        .doc-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 4pt; border: 0.5pt solid #eee; padding: 8pt; margin-top: 5pt; }
        .doc-item { display: flex; height: 14pt; }
        .doc-label { flex: 1; background: ${BG_LABEL}; border: 0.3pt solid #ddd; font-size: 6.5pt; font-weight: 800; display: flex; align-items: center; justify-content: flex-end; padding-right: 5pt; }
        .doc-val { width: 30pt; background: ${BG_LABEL}; border: 0.3pt solid #ddd; font-size: 6.5pt; font-weight: 800; display: flex; align-items: center; justify-content: center; }

        .observation-box { border: 1pt solid ${PINK}; background: #fffcfd; padding: 10pt; min-height: 60pt; margin-top: 10pt; font-size: 9pt; line-height: 1.4; }
        
        .clothes-box { display: flex; gap: 10pt; margin-top: 10pt; }
        .clothes-item { flex: 1; border: 0.5pt solid #eee; padding: 5pt; display: flex; align-items: center; }
        .clothes-label { font-size: 6pt; font-weight: 900; color: ${PINK}; transform: rotate(-90deg); width: 20pt; white-space: nowrap; }
        .clothes-val { flex: 1; text-align: center; font-size: 16pt; font-weight: 900; }
        .clothes-icon { width: 40pt; height: 40pt; display: flex; align-items: center; justify-content: center; opacity: 0.2; }

        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
        }
      </style>
    </head>
    <body>
      <div class="outer-border">
        <div class="inner-border">
          <div class="header">
            <h1 class="logo-text">YO VOY</h1>
            <span class="logo-subtext">${packageType.toUpperCase()}</span>
            <div class="pasajero-nombre">${apellido} ${nombre}</div>
            <div class="viaje-info">${tripName} | ${tripYear}</div>
          </div>

          <div class="grid-container">
            <div class="left-col">
              <div class="section-title">Datos del Pasajero</div>
              ${renderRow("DNI", pasajero.dni)}
              ${renderRow("Fecha Nacimiento", pasajero.fecha_nacimiento)}
              ${renderRow("Sexo", pasajero.sexo)}
              ${renderRow("E-mail", pasajero.email)}
              ${renderRow("Domicilio", pasajero.direccion)}
              ${renderRow("Teléfono Fijo", pasajero.telefono_fijo)}
              ${renderRow("Celular", pasajero.celular_personal)}
              ${renderRow("Provincia", (pasajero.ciudad || "") + " " + (pasajero.provincia || ""))}

              <div class="section-title">Datos del Contrato</div>
              ${renderRow("Nombre Padre/Tutor", pasajero.datos_del_pagador)}
              ${renderRow("Apellido Padre/Tutor", pasajero.responsable_apellido)}
              ${renderRow("Dirección Padre/Tutor", pasajero.responsable_direccion)}
              ${renderRow("DNI Padre/Tutor", pasajero.dni_responsable)}
              ${renderRow("Firmó", pasajero.firmo_contrato)}
              ${renderRow("Fecha de Firma", pasajero.fecha_firma)}
              ${renderRow("Celular 1", pasajero.celular_contacto_1)}
              ${renderRow("Celular 2", pasajero.celular_contacto_2)}
            </div>

            <div class="right-col">
              <div class="section-title">Datos del Viaje</div>
              ${renderRow("Colegio", pasajero.colegio)}
              <div style="display:flex; gap: 5pt">
                <div style="flex:1">${renderRow("Colectivo", pasajero.colectivo)}</div>
                <div style="flex:1">${renderRow("Emisión", pasajero.emision)}</div>
              </div>

              <div class="clothes-box">
                <div class="clothes-item">
                  <div class="clothes-label">TALLE</div>
                  <div class="clothes-val">${pasajero.talle || '-'}</div>
                </div>
                <div class="clothes-item">
                  <div class="clothes-label">BOLSO</div>
                  <div class="clothes-val">${pasajero.bolso ? 'SÍ' : 'NO'}</div>
                </div>
              </div>

              <div class="section-title">Documentación</div>
              <div class="doc-grid">
                ${[
                  { l: "DNI o Pasaporte", f: "dni_o_pasaporte" },
                  { l: "Fotocopia DNI", f: "fotocopia_de_dni" },
                  { l: "Foto Visa", f: "foto_visa" },
                  { l: "Ficha Médica", f: "ficha_medica" },
                  { l: "Partida Nacimiento", f: "partida_de_nacimiento" },
                  { l: "Vacuna", f: "vacuna" },
                  { l: "Permiso", f: "permiso" },
                  { l: "Visa", f: "visa" },
                  { l: "DNI Físico", f: "dni_fisico" },
                  { l: "Pasaporte", f: "pasaporte_europeo" },
                ].map(d => `
                  <div class="doc-item">
                    <div class="doc-label">${d.l}</div>
                    <div class="doc-val">${pasajero[d.f] ? 'SI' : 'NO'}</div>
                  </div>
                `).join('')}
              </div>

              <div class="section-title">Datos del Pago</div>
              ${renderRow("Monto Producto", pasajero.monto_producto)}
              ${renderRow("Monto Suplementario", pasajero.monto_suplementario)}
              ${renderRow("Monto Percepción", pasajero.monto_percepcion)}
              ${renderRow("CUI L/CUIT", pasajero.cuit_pagador)}
              ${renderRow("Categoría", pasajero.categoria_pago)}
              ${renderRow("Pagó", pasajero.pago_confirmado)}
            </div>
          </div>

          <div class="section-title">Observaciones</div>
          <div class="observation-box">
            ${pasajero.observaciones || "No se registran observaciones adicionales."}
          </div>

          <div style="margin-top: 40pt; display: flex; justify-content: space-around;">
            <div style="width: 150pt; border-top: 1pt solid ${PINK}; text-align: center; padding-top: 5pt; font-size: 8pt; font-weight: 700;">Firma de Conformidad</div>
            <div style="width: 150pt; border-top: 1pt solid ${PINK}; text-align: center; padding-top: 5pt; font-size: 8pt; font-weight: 700;">Sello Empresa</div>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

export const printPassengerFile = (
  pasajero: any,
  tripName?: string,
  tripYear?: string,
  packageType?: string
): void => {
  const html = generatePassengerFileHTML(pasajero, tripName, tripYear, packageType);
  const win = window.open("", "_blank");
  if (win) {
    win.document.write(html);
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
    }, 800);
  }
};
